export const LOGIN = '/BI_EX0001'

export const BUSCA = '/BI_WS0001'
export const CONFIGURACOES_DO_PERFIL = '/BI_WS0002'
export const MEUS_DADOS = '/BI_WS0003'
export const MS_REDEFINIR_SENHA = '/BI_WS0004'
export const MS_ALTERAR_EMAIL = '/BI_WS0005'
export const PERFIS_DE_ACESSO = '/BI_WS0008'
export const PERMISSOES_USUARIO = '/BI_WS0009'

export const CONFIGURACOES_EMPRESA = '/BI_WS0010'
export const PERFIL_DA_EMPRESA = '/BI_WS0011'
export const PLATAS_DA_EMPRESA = '/BI_WS0013'
export const USUARIOS_CADASTRADOS = '/BI_WS0014'
export const MEUS_PARCEIROS = '/BI_WS0017'
export const MEU_CONTRATO = '/BI_WS0019'

export const COLEGAS = '/BI_WS0026'
